export const OPEN_GATE = 'open-gate';
const openGate = ({ parkingPass }) => ({
  type: OPEN_GATE,
  payload: { parkingPass },
});
export default openGate;
